"use strict";
/* Generated from:
 * ap-northeast-1 (https://d33vqc0rt9ld30.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-2 (https://d1ane3fvebulky.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-3 (https://d2zq80gdmjim8k.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-south-1 (https://d2senuesg1djtx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-1 (https://doigdx0kgq9el.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-2 (https://d2stg8d246z9di.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ca-central-1 (https://d2s8ygphhesbe7.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-central-1 (https://d1mta8qj7i28i2.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-1 (https://d3teyb21fexa9r.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-2 (https://d1742qcu2c1ncx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-3 (https://d2d0mfegowb3wk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * sa-east-1 (https://d3c9jyj3w509b0.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-1 (https://d1uauaxba7bl26.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-2 (https://dnwj8swjjbsbt.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-1 (https://d68hl49wbnanq.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-2 (https://d201a2mn26r7lk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const connectorDefinitionVersion_1 = require("./connectorDefinitionVersion");
const resourceDefinition_1 = require("./resourceDefinition");
const deviceDefinition_1 = require("./deviceDefinition");
const loggerDefinitionVersion_1 = require("./loggerDefinitionVersion");
const functionDefinitionVersion_1 = require("./functionDefinitionVersion");
const group_1 = require("./group");
const connectorDefinition_1 = require("./connectorDefinition");
const functionDefinition_1 = require("./functionDefinition");
const subscriptionDefinitionVersion_1 = require("./subscriptionDefinitionVersion");
const coreDefinitionVersion_1 = require("./coreDefinitionVersion");
const loggerDefinition_1 = require("./loggerDefinition");
const coreDefinition_1 = require("./coreDefinition");
const deviceDefinitionVersion_1 = require("./deviceDefinitionVersion");
const subscriptionDefinition_1 = require("./subscriptionDefinition");
const resourceDefinitionVersion_1 = require("./resourceDefinitionVersion");
const groupVersion_1 = require("./groupVersion");
var Greengrass;
(function (Greengrass) {
    Greengrass.ConnectorDefinitionVersion = connectorDefinitionVersion_1.default;
    Greengrass.ResourceDefinition = resourceDefinition_1.default;
    Greengrass.DeviceDefinition = deviceDefinition_1.default;
    Greengrass.LoggerDefinitionVersion = loggerDefinitionVersion_1.default;
    Greengrass.FunctionDefinitionVersion = functionDefinitionVersion_1.default;
    Greengrass.Group = group_1.default;
    Greengrass.ConnectorDefinition = connectorDefinition_1.default;
    Greengrass.FunctionDefinition = functionDefinition_1.default;
    Greengrass.SubscriptionDefinitionVersion = subscriptionDefinitionVersion_1.default;
    Greengrass.CoreDefinitionVersion = coreDefinitionVersion_1.default;
    Greengrass.LoggerDefinition = loggerDefinition_1.default;
    Greengrass.CoreDefinition = coreDefinition_1.default;
    Greengrass.DeviceDefinitionVersion = deviceDefinitionVersion_1.default;
    Greengrass.SubscriptionDefinition = subscriptionDefinition_1.default;
    Greengrass.ResourceDefinitionVersion = resourceDefinitionVersion_1.default;
    Greengrass.GroupVersion = groupVersion_1.default;
})(Greengrass = exports.Greengrass || (exports.Greengrass = {}));
